import {AlertIcon} from '@primer/octicons-react'
import {ActionItem} from '../action-items/ActionItem'
import {ActionItemsList} from '../action-items/ActionItemsList'

export function ActivityError() {
  return (
    <ActionItemsList>
      <ActionItem
        title="Unable to load activity"
        description="Something went wrong while loading recent activity."
        leadingIcon={AlertIcon}
        variant="danger"
      />
    </ActionItemsList>
  )
}
